import type { FieldValues } from 'react-hook-form'
import type { EntityUpdatePayload } from '../../types'

export const toEntityPayload = (formData: FieldValues): EntityUpdatePayload => {
  const {
    agency_credit_rating_id,
    agency_credit_rating_date,
    form_of_organization,
    jurisdiction_country,
    jurisdiction_of_organization,
    jurisdiction_of_organization_identifier,
    is_utility_company,
    is_energy_trader,
    industry_classification_code,
    size_type,
    size_dollars,
    sanctions_flag,
    sanctions_details,
    notices_line1,
    notices_line2,
    notices_city,
    notices_region,
    notices_postal_code,
    notices_country,
    billing_line1,
    billing_line2,
    billing_city,
    billing_region,
    billing_postal_code,
    billing_country
  } = formData

  return {
    agency_credit_rating_id,
    agency_credit_rating_date,
    form_of_organization,
    jurisdiction_country,
    jurisdiction_of_organization,
    jurisdiction_of_organization_identifier,
    is_utility_company: 'Yes' === is_utility_company,
    is_energy_trader: 'Yes' === is_energy_trader,
    industry_classification_code,
    size_type,
    size_dollars,
    sanctions_flag,
    sanctions_details,
    notices_address: {
      line1: notices_line1,
      line2: notices_line2,
      city: notices_city,
      region: notices_region,
      postal_code: notices_postal_code,
      country: notices_country
    },
    billing_address: {
      line1: billing_line1,
      line2: billing_line2,
      city: billing_city,
      region: billing_region,
      postal_code: billing_postal_code,
      country: billing_country
    }
  }
}
